var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.target && _vm.canWatchNow(_vm.target)
    ? _c(
        "b-btn",
        {
          staticClass: "float-right",
          attrs: { variant: "primary", size: "lg", to: _vm.target.path },
        },
        [_vm._v(_vm._s(_vm.sayAction(_vm.target)) + " now")]
      )
    : _vm.needsSubscription(_vm.target)
    ? _c(
        "b-btn",
        {
          staticClass: "watch subscribe-to-watch",
          attrs: {
            size: "lg",
            variant: "warning",
            to: _vm.target.preview || {
              path: "/members",
              query: { then: _vm.target.path },
            },
          },
        },
        [_vm._v("subscribe to " + _vm._s(_vm.sayAction(_vm.target)))]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }